//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//信用证开证申请
// const applicationForCredit = () =>
//   import(
//     /* webpackChunkName:'applicationForCredit' */ '@/pages/letterOfCredit/issuing/applicationForCredit/add.vue'
//   );

//信用证开证查询
const searchIssueCredit = () =>
  import(
    /* webpackChunkName:'searchIssueCredit' */ '@/pages/letterOfCredit/issuing/searchCredit/list.vue'
  );

//信用证收证查询
const searchReceiveCredit = () =>
  import(
    /* webpackChunkName:'searchReceiveCredit' */ '@/pages/letterOfCredit/receiving/searchCredit/list.vue'
  );

//信用证收证详情或承兑
const detailOrAcceptCredit = () =>
  import(
    /* webpackChunkName:'detailOrAcceptCredit' */ '@/pages/letterOfCredit/receiving/detailOrAcceptCredit/add.vue'
  );

//信用证收证登记
const registerForCredit = () =>
  import(
    /* webpackChunkName:'registerForCredit' */ '@/pages/letterOfCredit/receiving/registerForCredit/index.vue'
  );

//信用证收证认领
const claimForCredit = () =>
  import(
    /* webpackChunkName:'claimForCredit' */ '@/pages/letterOfCredit/receiving/claimForCredit/index.vue'
  );

//信用证开证
const issuing = () =>
  import(/* webpackChunkName:'issuing' */ '@/pages/letterOfCredit/issuing/issuing/add.vue');

//信用证承兑
const acceptance = () =>
  import(/* webpackChunkName:'acceptance' */ '@/pages/letterOfCredit/issuing/acceptance/add.vue');

const letterOfCreditRouter = {
  path: '/letterOfCredit',
  component: index,
  children: [
    {
      path: 'applicationForCredit',
      name: 'applicationForLC',
      component: () => import('@/pages/letterOfCredit/issuing/applicationForCredit/add.vue'),
      meta: {
        keepAlive: true,
        title: '信用证开证申请',
      },
    },
    {
      path: 'searchIssueCredit',
      name: 'searchIssueCredit',
      component: searchIssueCredit,
      meta: {
        keepAlive: true,
        title: '信用证开证查询',
      },
    },
    {
      path: 'searchReceiveCredit',
      name: 'searchReceiveCreditLC',
      component: searchReceiveCredit,
      meta: {
        keepAlive: true,
        title: '信用证收证查询',
      },
    },
    {
      path: 'detailCredit',
      name: 'detailCreditLC',
      component: detailOrAcceptCredit,
      meta: {
        keepAlive: true,
        title: '信用证收证详情',
      },
    },
    {
      path: 'acceptCredit',
      name: 'acceptCreditLC',
      component: detailOrAcceptCredit,
      meta: {
        keepAlive: true,
        title: '信用证收证承兑',
      },
    },
    {
      path: 'registerForCredit',
      name: 'registerForCreditLC',
      component: registerForCredit,
      meta: {
        keepAlive: true,
        title: '信用证收证登记',
      },
    },
    {
      path: 'claimForCredit',
      name: 'claimForCreditLC',
      component: claimForCredit,
      meta: {
        keepAlive: true,
        title: '信用证收证认领',
      },
    },
    {
      path: 'issuing',
      name: 'issuingLC',
      component: issuing,
      meta: {
        keepAlive: true,
        title: '信用证开证',
      },
    },
    {
      path: 'acceptance',
      name: 'acceptanceLC',
      component: acceptance,
      meta: {
        keepAlive: true,
        title: '信用证开证承兑',
      },
    },
    {
      path: 'issuingDetail',
      name: 'issuingDetailLC',
      component: acceptance,
      meta: {
        keepAlive: true,
        title: '信用证开证详情',
      },
    },
  ],
};
export default letterOfCreditRouter;
